import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import ModalManager from '../../../Utility/ModalManager';
export default function ModalContainer() {
    const [modal, setModal] = useState();
    useEffect(() => {
        ModalManager.registerSetState(setModal);
    }, []);
    return _jsx(_Fragment, { children: modal });
}
//# sourceMappingURL=ModalContainer.js.map